import { CircularProgress } from '@mui/material';
import React from 'react';

import * as Styled from './delete-life-area-loading.style';

export const DeleteLifeAreaLoading: React.FC = () => (
  <Styled.Container>
    <CircularProgress />
  </Styled.Container>
);
